import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Separator } from 'widgets/Separator'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { links } from 'utils/constants'

type FlowSelectionPageProps = {
  handleSelection: (isGroup: boolean) => void
}

export const FlowSelectionPage = ({ handleSelection }: FlowSelectionPageProps) => {
  const navigation = useNavigation<any>()
  const startGroupCreationFlow = () => {
    handleSelection(true)
    navigation.navigate(links.UPSPACE_NAME_PAGE)
  }

  const startProgramCreationFlow = () => {
    handleSelection(false)
    navigation.navigate(links.PROGRAM_QUESTIONS_PAGE)
  }

  return (
    <Box flex={1} backgroundColor='white'>
      <Box
        borderRadius='sm'
        backgroundColor='v2lightGrey'
        margin={{ top: 'lg', horizontal: 'sm' }}
        padding='smd'
      >
        <Pressable onPress={startGroupCreationFlow}>
          <Box align='center' justifyContent='center'>
            <Box style={{ marginVertical: -8 }}>
              <Title size='xxl' numberOfLines={1}>
                👩🏻‍🦱👨🏾👱🏼‍♀️
              </Title>
            </Box>
            <Text bold color='black' fontSize='lg' numberOfLines={1}>
              Create Group
            </Text>
            <Box margin={{ top: 'sm', bottom: 'md' }}>
              <Text color='black' fontSize='sm' align='center'>
                Create an Upspace group for your following with your own dedicated feed. Users can
                compete on the leaderboard and interact within the group chat.
              </Text>
            </Box>
          </Box>
        </Pressable>
      </Box>

      <Box margin={{ horizontal: 'md' }} padding='md'>
        <Separator />
      </Box>

      <Box
        borderRadius='sm'
        backgroundColor='v2lightGrey'
        margin={{ horizontal: 'sm' }}
        padding='smd'
      >
        <Pressable onPress={startProgramCreationFlow}>
          <Box align='center' justifyContent='center'>
            <Box style={{ marginVertical: -8 }}>
              <Title size='xxl' numberOfLines={1}>
                👨‍💻
              </Title>
            </Box>
            <Text bold color='black' fontSize='lg' numberOfLines={1}>
              Create Program
            </Text>
            <Box margin={{ top: 'sm', bottom: 'md' }}>
              <Text color='black' fontSize='sm' align='center'>
                Build a program with a list of daily actions for your following to complete.
                Programs have dedicated feeds, leaderboards and group chats. The difference between
                a group and program is that you can curate a series of actions in advance.
              </Text>
            </Box>
          </Box>
        </Pressable>
      </Box>
    </Box>
  )
}
